import type { BaseDictionaryItem } from './dictionaryUtils'

export interface AgreementStatusItem extends BaseDictionaryItem {
  text: string
}

export type AgreementOpportunityItem = BaseDictionaryItem & {
  weight: number
}

export const AGREEMENT_STATUS: readonly AgreementStatusItem[] = [
  {
    key: 'Idle',
    label: 'Idle',
    text: 'Idle',
    localeKey: 'ui.entities.agreement.status.idle',
    icon: 'circle-small',
    color: 'brand'
  },
  {
    key: 'Unresponsive',
    label: 'Unresponsive',
    text: 'Unresponsive',
    localeKey: 'ui.entities.agreement.status.unresponsive',
    icon: 'phone-missed',
    color: 'warning'
  },
  {
    key: 'Unreachable',
    label: 'Unreachable',
    text: 'Unreachable',
    localeKey: 'ui.entities.agreement.status.unreachable',
    icon: 'ban',
    color: 'error'
  },
  {
    key: 'Uncontactable',
    label: 'Uncontactable',
    text: 'Uncontactable',
    localeKey: 'ui.entities.agreement.status.uncontactable',
    icon: 'ban',
    color: 'error'
  },
  {
    key: 'Contacted',
    label: 'Contacted',
    text: 'Contacted',
    localeKey: 'ui.entities.agreement.status.contacted',
    icon: 'phone',
    color: 'brand'
  },
  {
    key: 'Appointed',
    label: 'Appointed',
    text: 'Appointed',
    localeKey: 'ui.entities.agreement.status.appointed',
    icon: 'calendar',
    color: 'info'
  },
  {
    key: 'Complete',
    label: 'Complete',
    text: 'Complete',
    localeKey: 'ui.entities.agreement.status.complete',
    icon: 'check',
    color: 'success'
  },
  {
    key: 'Dealt',
    label: 'Dealt',
    text: 'Dealt',
    localeKey: 'ui.entities.agreement.status.dealt',
    icon: 'check',
    color: 'success'
  },
  {
    key: 'Settled',
    label: 'Settled',
    text: 'Settled',
    localeKey: 'ui.entities.agreement.status.settled',
    icon: 'check',
    color: 'success'
  },
  {
    key: 'Refinanced',
    label: 'Refinanced',
    text: 'Refinanced',
    localeKey: 'ui.entities.agreement.status.refinanced',
    icon: 'check',
    color: 'success'
  },
  {
    key: 'Handed Back',
    label: 'Handed Back',
    text: 'Handed Back',
    localeKey: 'ui.entities.agreement.status.handedBack',
    icon: 'check',
    color: 'success'
  },
  {
    key: 'Sold',
    label: 'Sold',
    text: 'Sold',
    localeKey: 'ui.entities.agreement.status.sold',
    icon: 'check',
    color: 'success'
  },
  {
    key: 'Not Sold',
    label: 'Not Sold',
    text: 'Not Sold',
    localeKey: 'ui.entities.agreement.status.notSold',
    icon: 'xmark',
    color: 'error'
  },
  {
    key: 'ERROR',
    label: 'ERROR',
    text: 'ERROR',
    localeKey: 'dev.dataMappingError',
    icon: 'bug',
    color: 'error'
  }
] as const

export const AGREEMENT_OPPORTUNITY: readonly AgreementOpportunityItem[] = [
  {
    key: 'Extra Hot',
    label: 'Extra Hot',
    icon: 'fire',
    color: 'error',
    weight: 3
  },
  {
    key: 'Hot',
    label: 'Hot',
    icon: 'fire',
    color: 'warning',
    weight: 2
  },
  {
    key: 'Mild',
    label: 'Mild',
    icon: 'fire',
    color: 'secondary',
    weight: 1
  },
  {
    key: 'ERROR',
    label: 'ERROR',
    localeKey: 'dev.dataMappingError',
    icon: 'bug',
    color: 'error',
    weight: 0
  }
] as const
